import FilesOptions from '../../../../common/file/upload/const/FilesOptions';
import HttpService from '../../../../common/http/HttpService';
import MasterDataFileEndpoint from '../const/MasterDataFileEndpoint';
import downloadFile from '../../../../common/download/downloadFile';
import VcomProvider from '../../../../VcomProvider';

function matchMasterDataFileType(fileMimeType) {
  const result = Object.values(FilesOptions.FILE_MIME_MATCHING).find(
    (matchMimeType) => matchMimeType.mimeType === fileMimeType,
  );
  return result.fileExtension;
}

function prepareFiles(files) {
  const preparedFiles = files.map((file) => {
    const fileType = matchMasterDataFileType(file.type);
    const content = file.dataURL.split('base64,')[1];
    const extensionIndex = file.name.lastIndexOf('.');
    const fileNameWithoutExtension = file.name.substring(0, extensionIndex);
    return {
      fileName: extensionIndex === -1 ? file.name : fileNameWithoutExtension,
      type: fileType,
      content,
    };
  });
  return preparedFiles;
}

async function getContent(id) {
  const systemId = VcomProvider.adminSystemId;
  await downloadFile(MasterDataFileEndpoint.GET_CONTENT, { systemId, id });
}

async function getSiteContent(id) {
  const systemId = VcomProvider.adminSystemId;
  await downloadFile(MasterDataFileEndpoint.GET_SITE_CONTENT, { systemId, id });
}

function saveFiles(files) {
  const systemId = VcomProvider.adminSystemId;
  return HttpService.post(MasterDataFileEndpoint.SAVE_FILES, { systemId, files });
}

async function saveSiteFiles(files, id, elementId) {
  const systemId = VcomProvider.adminSystemId;
  const response = await HttpService.post(
    MasterDataFileEndpoint.SAVE_SITE_FILES,
    {
      systemId,
      files,
      id,
      elementId,
    },
  );

  return response.data;
}

function removeFile(fileId) {
  const systemId = VcomProvider.adminSystemId;
  HttpService.post(MasterDataFileEndpoint.REMOVE_FILE, { systemId, fileId });
}

async function removeSiteFile(fileId) {
  const systemId = VcomProvider.adminSystemId;
  return HttpService.post(MasterDataFileEndpoint.REMOVE_SITE_FILE, { systemId, fileId });
}

async function changeDetails(file) {
  const payload = {
    id: file.id,
    title: file.title,
    description: file.description,
  };
  const systemId = VcomProvider.adminSystemId;
  return HttpService.post(MasterDataFileEndpoint.CHANGE_DETAILS, { systemId, payload });
}

async function changeSiteDetails(file) {
  const payload = {
    id: file.id,
    title: file.title,
    description: file.description,
  };
  const systemId = VcomProvider.adminSystemId;
  return HttpService.post(MasterDataFileEndpoint.CHANGE_SITE_DETAILS, { systemId, payload });
}

async function getFiles() {
  const systemId = VcomProvider.adminSystemId;
  return HttpService.post(MasterDataFileEndpoint.GET_FILES, { systemId });
}

async function getSiteFiles(id, elementId) {
  const systemId = VcomProvider.adminSystemId;
  const response = await HttpService.post(
    MasterDataFileEndpoint.GET_SITE_FILES,
    {
      systemId,
      id,
      elementId,
    },
  );
  return response.data;
}

const MasterDataFileService = {
  prepareFiles,
  saveFiles,
  saveSiteFiles,
  getFiles,
  getSiteFiles,
  getContent,
  getSiteContent,
  removeFile,
  removeSiteFile,
  changeDetails,
  changeSiteDetails,
};

export default MasterDataFileService;
